import { useState } from 'react';
import { SubItemFormFilling } from '../../Filling/Types';
import TextFieldList from '../SubitemExceptions/TextList/TextFieldList';
import AutoCompleteUnique from '../SubitemExceptions/Unique/AutoCompleteUnique';
import Assinatura from '../SubitemExceptions/Assinatura/Assinatura';
import Avaliacao from '../SubitemExceptions/Avaliation/Avaliacao';
import TextFieldComp from '../TextFieldComp';
import AutoCompleteMultiple from '../SubitemExceptions/Multiple/AutoCompleteMultiple';
import DateComp from '../SubitemExceptions/Date/DateComp';
import HourComp from '../SubitemExceptions/Hour/HourComp';
import PlacaComp from '../SubitemExceptions/Placa/PlacaComp';

type params = {
  subItem: SubItemFormFilling,
}

export default function SubItemFilling({ subItem }: params) {
  const [telefone, setTelefone] = useState<string | null>(null);
  const [rg, setRg] = useState<string | null>(null);
  const [cep, setCep] = useState<string | null>(null);
  const [cpf, setCpf] = useState<string | null>(null);
  const [placa, setPlaca] = useState<string | null>(null);
  const [email, setEmail] = useState<string | null>(null);
  const [unico, setUnico] = useState<string | null>(null);
  const [multiplo, setMultiplo] = useState<string[] | null>(null);
  const [data, setData] = useState<Date | number | null>(null);
  const [textoCurto, setTextoCurto] = useState<string | null>(null);
  const [textoLongo, setTextoLongo] = useState<string | null>(null);
  const [hora, setHora] = useState<Date | null>(null);
  const [numero, setNumero] = useState<string | null>(null);
  const [lista, setLista] = useState<{ texto: string }[] | null>(null);
  const [assinatura, setAssinatura] = useState<string | null>(null);
  const [avaliacao, setAvaliacao] = useState<number | null>(null);

  const obrigatoriedade = subItem.obrigatoriedade?.preenchimento

  const renderResponseTypes = () => {
    switch (subItem.tipo) {
      case 'numero':
        return (
          <TextFieldComp
            subitem={subItem}
            required={obrigatoriedade}
            type={'number'}
            tipo={subItem.tipo}
            value={numero}
            setValue={setNumero}
          />
        )
      case 'textoCurto':
        return (
          <TextFieldComp
            subitem={subItem}
            required={obrigatoriedade}
            tipo={subItem.tipo}
            value={textoCurto}
            setValue={setTextoCurto}
          />
        )
      case 'textoLongo':
        return (
          <TextFieldComp
            subitem={subItem}
            required={obrigatoriedade}
            tipo={subItem.tipo}
            value={textoLongo}
            setValue={setTextoLongo}
            multiple={true}
          />
        )
      case 'email':
        return (
          <TextFieldComp
            subitem={subItem}
            required={obrigatoriedade}
            type={'email'}
            tipo={subItem.tipo}
            value={email}
            setValue={setEmail}
          />
        )
      case 'telefone':
        return (
          <TextFieldComp
            subitem={subItem}
            required={obrigatoriedade}
            tipo={subItem.tipo}
            value={telefone}
            setValue={setTelefone}
          />
        )
      case 'rg':
        return (
          <TextFieldComp
            subitem={subItem}
            required={obrigatoriedade}
            tipo={subItem.tipo}
            value={rg}
            setValue={setRg}
          />
        )
      case 'cep':
        return (
          <TextFieldComp
            subitem={subItem}
            required={obrigatoriedade}
            tipo={subItem.tipo}
            value={cep}
            setValue={setCep}
          />
        )
      case 'cpfcnpj':
        return (
          <TextFieldComp
            subitem={subItem}
            required={obrigatoriedade}
            tipo={subItem.tipo}
            value={cpf}
            setValue={setCpf}
          />
        )
      case 'assinatura':
        return (
          <>
            <Assinatura
              assinatura={assinatura}
              setAssinatura={setAssinatura}
              subitem={subItem}
            />
          </>
        )
      case 'list':
        return (
          <>
            <TextFieldList
              lista={lista}
              setLista={setLista}
              subitem={subItem}
            />
          </>
        )
      case 'hora':
        return (
          <HourComp
            hora={hora}
            setHora={setHora}
            subitem={subItem}
          />
        )
      case 'data':
        return (
          <DateComp
            data={data}
            setData={setData}
            subitem={subItem}
          />
        )
      case 'placa':
        return (
          <PlacaComp
            placa={placa}
            setPlaca={setPlaca}
            subitem={subItem}
          />
        )
      case 'avaliacao':
        return (
          <Avaliacao
            avaliacao={avaliacao}
            setAvaliacao={setAvaliacao}
            subitem={subItem}
          />
        )
      case 'multiple':
        return (
          <AutoCompleteMultiple
            subitem={subItem}
            setMultiplo={setMultiplo}
            multiplo={multiplo}
          />
        )
      case 'unique':
        return (
          <AutoCompleteUnique
            subitem={subItem}
            unico={unico}
            setUnico={setUnico}
          />
        )
      default:
        return (
          <></>
        )
    }
  }

  return (
    <>
      {renderResponseTypes()}
    </>
  )
}